import LayoutPadrao from 'lg-vue-components/layoutPadrao'
export default [
   {
      path: '/',
      redirect: 'grupos-usuario',
      component: LayoutPadrao,
      children: [
         {
            path: '/grupos-usuario',
            name: 'grupos-usuario',
            component: () => import('../pages/lista-grupo-usuario/lista-grupo-usuario.vue')
         }
      ]
   },
   {
      path: '/',
      redirect: 'grupos-usuario',
      component: LayoutPadrao,
      children: [
         {
            path: '/grupos-usuario/:id',
            name: 'grupos-usuario-editar',
            component: () => import('../pages/editar-grupo-usuario/editar-grupo-usuario.vue')
         }
      ]
   }
]
